import gql from "graphql-tag";
// Login user
export const ADD_ITEM_TO_MARKETLIST_MUTATION = gql`
  mutation addItemToMarketlist(
    $marketlist_id: String!
    $cartitem: CartitemInput!
  ) {
    addItemToMarketlist(marketlist_id: $marketlist_id, cartitem: $cartitem) {
      id
      name
      items {
        ... on Cartitem {
          item
          item_name
          image
          quantity
          price
          price_7_pct
          supplier
          supplier_name
          unit
        }
      }
    }
  }
`;
